module.exports = __webpack_public_path__ + "img/logo-preta-120.f9ab494c.png";